window.companyIndex = function(companiesData, blockedCompanyIds) {
  return {
    // 企業選択機能
    selectedCompanies: [],

    // 配信グループモーダル制御
    isOpen: false,

    // ブロックモーダル制御
    isBlockModalOpen: false,
    blockForm: {
      block_type: '',
      reason: ''
    },

    get selectedCount() {
      return this.selectedCompanies.length;
    },

    get allOnPageSelected() {
      const pageCompanyIds = companiesData || [];
      const blockedIds = blockedCompanyIds || [];
      const selectableCompanyIds = pageCompanyIds.filter(id => !blockedIds.includes(id));
      return selectableCompanyIds.length > 0 && selectableCompanyIds.every(id => this.selectedCompanies.includes(id));
    },

    init() {
      // ページ読み込み時に選択状態をリセット
      this.selectedCompanies = [];
    },

    isSelected(companyId) {
      return this.selectedCompanies.includes(companyId);
    },

    toggleSelection(companyId) {
      const index = this.selectedCompanies.indexOf(companyId);
      if (index > -1) {
        this.selectedCompanies.splice(index, 1);
      } else {
        this.selectedCompanies.push(companyId);
      }
    },

    toggleAllOnPage(event) {
      const pageCompanyIds = companiesData || [];
      const blockedIds = blockedCompanyIds || [];
      const selectableCompanyIds = pageCompanyIds.filter(id => !blockedIds.includes(id));

      if (event.target.checked) {
        // 全選択
        selectableCompanyIds.forEach(id => {
          if (!this.selectedCompanies.includes(id)) {
            this.selectedCompanies.push(id);
          }
        });
      } else {
        // 全解除
        this.selectedCompanies = this.selectedCompanies.filter(id => !selectableCompanyIds.includes(id));
      }
    },

    // ブロックモーダル制御
    openBlockModal(event) {
      event.preventDefault();
      if (this.selectedCount === 0) {
        return false;
      }
      this.blockForm.block_type = '';
      this.blockForm.reason = '';
      this.isBlockModalOpen = true;
    },

    closeBlockModal() {
      this.isBlockModalOpen = false;
    }
  }
}